export default __webpack_public_path__ + "static/media/iconos-moodulos-Crol-1024x930-1-512x465.fd5429e1.png";